import type { ServerLoadEvent } from '@sveltejs/kit';
import { error } from '@sveltejs/kit';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getTalksGalleryFilterSections } from '../getTalksGalleryFilterSections/getTalksGalleryFilterSections';
import { Config } from '#lib/constants/config.js';
import { SiteNames } from '#lib/constants/site-names.js';
import { EditionsRoutes } from '#lib/websites/editions/constants/routes.js';
import {
	getTalksGalleryPage,
	type TalksGalleryParams,
} from '#lib/websites/talks/api/getTalksGalleryPage.js';
import type { FullSeo } from '$global/features/seo/types';

export const TALKS_GALLERY_LIMIT = 12;

export const getTalksGalleryBaseParams = (
	date: string
): TalksGalleryParams => ({
	now: date,
	sort: '-release_date',
	limit: TALKS_GALLERY_LIMIT,
	offset: 0,
});

export const talksGalleryPageServerLoad = async ({
	parent,
	fetch,
}: ServerLoadEvent) => {
	const parentData = await parent();
	dayjs.extend(utc);

	try {
		const currentDate = dayjs().utc().toISOString();

		const talks = await getTalksGalleryPage(
			fetch,
			getTalksGalleryBaseParams(currentDate)
		);

		const seo = {
			...talks.seo,
			site: SiteNames.HeniEditions,
			url: `${Config.Domain}${EditionsRoutes.Gallery}`,
		} as FullSeo;

		const filterSections = getTalksGalleryFilterSections({
			filterOptions: talks.filterOptions,
		});

		const data = {
			...parentData,
			currentDate,
			filterSections,
			talks,
			seo,
		};

		return data;
	} catch {
		error(404, 'Not found');
	}
};
